import React, { useState } from "react";
import Box from "@mui/material/Box";
import CommentItem from "./CommentItem";
import EmptyCommentsState from "./EmptyCommentsState";

const COMMENTS_PER_PAGE = 2;

const CommentsList = ({ comments }) => {
    const [visibleCount, setVisibleCount] = useState(COMMENTS_PER_PAGE);

    const visibleComments = comments.slice(0, visibleCount);
    const hasMoreComments = visibleCount < comments.length;

    const handleSeeMore = () => {
        setVisibleCount((prev) => prev + COMMENTS_PER_PAGE);
    };

    if (comments.length === 0) {
        return <EmptyCommentsState />;
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            {visibleComments.map((commentItem, index) => (
                <CommentItem
                    key={commentItem.id}
                    commentItem={commentItem}
                    showBorder={index < visibleComments.length - 1 || hasMoreComments}
                />
            ))}

            {hasMoreComments && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingBottom: "30px",
                    }}
                >
                    <Box
                        component="button"
                        onClick={handleSeeMore}
                        sx={{
                            padding: "12px 24px",
                            borderRadius: "8px",
                            border: "1px solid #D5DCE1",
                            background: "#FFF",
                            color: "#405261",
                            fontFamily: "Inter",
                            fontSize: "16px",
                            fontWeight: 500,
                            cursor: "pointer",
                            "&:hover": {
                                background: "#F5F7F9",
                            },
                        }}
                    >
                        See All Comments
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default CommentsList;
